<div class="content-container">
    <div>
        <mat-form-field appearance="outline" class="margin-right">
            <mat-label>Clear width</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="shelf?.box?.width" (ngModelChange)="shelf.box.width = $event"
                class="text-right" autoComplete="off">
        </mat-form-field>
        <mat-form-field appearance="outline" class="margin-right">
            <mat-label>Height from floor to table</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="shelf?.box?.height" (ngModelChange)="shelf.box.height = $event"
                class="text-right" autoComplete="off">
        </mat-form-field>
        <mat-form-field appearance="outline" class="margin-right">
            <mat-label>Depth of baggage compartment</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="shelf?.box?.length" (ngModelChange)="shelf.box.length = $event"
                class="text-right" autoComplete="off">
        </mat-form-field>
        <mat-form-field appearance="outline" class="margin-right">
            <mat-label>Compartment height from floor</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="podest?.height" (ngModelChange)="podest.height = $event"
                class="text-right" autoComplete="off">
        </mat-form-field>
    </div>
    <!-- Propertys below don't need to be shown since the proertys aren't used in the algorithm yet -->
    <div *ngIf="false">
        <mat-form-field appearance="outline" class="form-field text-right">
            <mat-label>Anzahl Steckdosen</mat-label>
            <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="table?.socketAmount"
                (ngModelChange)="table.socketAmount = $event" autoComplete="off">
        </mat-form-field>
        <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="table?.tableLeg"
            (ngModelChange)="table.tableLeg = $event" class="margin-right form-field">
            Tischbein
        </mat-checkbox>
        <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="table?.foldingElement"
            (ngModelChange)="table.foldingElement = $event" class="margin-right form-field">
            Tisch mit Ausklappelement
        </mat-checkbox>
        <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="table?.pullOutElement"
            (ngModelChange)="table.pullOutElement = $event" class="margin-right form-field">
            Tisch mit Ausziehelement
        </mat-checkbox>
    </div>
</div>